import React from 'react';
import { Button } from 'react-bootstrap';
import PagedEntitiesList from '../../common/components/PagedEntitiesList';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { withTranslation } from 'react-i18next';
import ui from '../../common/services/ui';
import { ConfirmationButton } from '../../common/components/formControls';
import { faEye, faPenToSquare } from '@fortawesome/free-regular-svg-icons';

const List = ({ t, onClick, onDelete, isReadonly, ...rest }) => {
	const columns = [
		{
			header: t('CenterHoliday_Term'),
			accessor: 'term.name',
			sortable: true
		},
		{
			header: t('CenterHoliday_StartDate'),
			accessor: 'startDate',
			cell: (startDate) => ui.formatDate(startDate),
			sortable: true
		},
		{
			header: t('CenterHoliday_EndDate'),
			accessor: 'endDate',
			cell: (endDate) => ui.formatDate(endDate),
			sortable: true
		},
		{
			header: t('CenterHoliday_IsHoliday'),
			accessor: 'isHoliday',
			sortable: true,
			cell: (isHoliday) => isHoliday ? <span style={{ color: 'red' }}>{t('CenterHoliday_Holiday')}</span> : <span style={{ color: 'green' }}>{t('CenterHoliday_WorkingDay')}</span>
		},
		{
			header: t('Common_Actions'),
			accessor: 'id',
			cell: (id, row) => (<div>
				<Button onClick={() => onClick(row)} className='btn btn-teal'><FontAwesomeIcon icon={isReadonly ? faEye : faPenToSquare} /> {t(isReadonly ? 'Common_View' : 'Common_Edit')}</Button>&nbsp;
				{!isReadonly && <ConfirmationButton onConfirmation={() => onDelete(id)} confirmationTitle={t('CenterHoliday_DeleteConfirmationTitle')}
					confirmationMessage={t('CenterHoliday_DeleteConfirmationMessage')} displayType={'inline'} label={t('Common_Delete')}></ConfirmationButton>}
				</div>)
		}
	];
	return (
		<div>
			{!isReadonly && <Button onClick={() => onClick()} className='btn btn-teal'> {t('Common_New')}</Button>} 
			<PagedEntitiesList columns={columns} {...rest} />
		</div>
	);
};

export default withTranslation()(List);